import packageInfo from "../package.json";

export const API_PROXIES = "/";
const inactivityAutoLogoutTime = process.env.REACT_APP_INATIVITY_AUTO_LOGOUT
  ? Number(`${process.env.REACT_APP_INATIVITY_AUTO_LOGOUT}`)
  : 900000;
const inactivityWarningTime = process.env.REACT_APP_INATIVITY_WARNING
  ? Number(`${process.env.REACT_APP_INATIVITY_WARNING}`)
  : 600000;

const getTenantName = () =>{
  const nameSpace:any = sessionStorage.getItem('namespace') || process.env.REACT_APP_NAMESPACE;
  if(nameSpace) {
    let tenantName = `${nameSpace?.split("-").slice(-2).join('-')}`;
    return tenantName
  }
  
};

const environment = {
  production: false,
  api: `${process.env.REACT_APP_API ? process.env.REACT_APP_API : API_PROXIES}`,
  gcpEndPoint: "https://us-central1-cv20-plat-nonprod-product.cloudfunctions.net/gdprPortal",
  // gcpEndPoint: "http://localhost:8080",
  apigeeEndpoint: `${
    process.env.REACT_APP_APIGEE_ENDPOINT
      ? process.env.REACT_APP_APIGEE_ENDPOINT
      : ""
  }`,
  namespace: `${
    process.env.REACT_APP_NAMESPACE ? process.env.REACT_APP_NAMESPACE : ""
  }`,
  authpath: 'authentication-service',
  userManagementPath: 'user-management-service',
  accessControlPath: 'access-control-service',
  organizationPath: 'organization-service',
  assetManagementPath: 'asset-management-service',
  configurationPath: 'configuration-service',
  notificationPath: 'notification-service',
  surveyPath: 'survey-service',
  metadataPath: 'metadata-service',
  migrationPath: 'migration-service',
  eventPath: 'event-service',
  carePlanPath: 'careplan-service',
  conditionPath: 'condition-service',
  careTeamPath: 'care-team-service',
  zenDeskPath: 'ticket-service',
  apikey: process.env.REACT_APP_API_KEY || "",
  orgId: process.env.REACT_APP_ORG_ID || "",
  version: packageInfo.version,
  inactivityAutoLogoutTime,
  inactivityWarningTime,
  ENV_TENANT_NAME: getTenantName(),
  ENV_SOLUTION_NAME: "bi-gdpr"
};

export default environment;
